import {BaseContainerModel} from "../../base-container.model";
import { bl_wf_md_process_status_link_RowClass, bl_wf_md_process_status_link_RowInterface } from "../../../dbschema";

export class WfMdProcessStatusLinkContainerModel extends BaseContainerModel{
  bl_wf_md_process_status_link: bl_wf_md_process_status_link_RowInterface = new bl_wf_md_process_status_link_RowClass();
}
